import React from "react";
import "@docsearch/css";
import { DocSearch } from "@docsearch/react";

const DocHubHero = () => {
  return (
    <section
      className="hero"
      style={{
        backgroundImage: `url('/icons/icon-hero-background.svg')`,
        padding: "40px 20px",
        textAlign: "center",
      }}
    >
      <div className="heroContent">
        <h1 className="heroTitle">Sysdig Docs</h1>
      </div>

      {/* Algolia DocSearch + Kapa AI button */}
      <div
        style={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
          marginTop: "20px"
        }}
      >
        {/* Algolia DocSearch input */}
        <DocSearch
          appId="CZBH9K9RTG"
          apiKey="d4b78c13f99587e2c9c0d636f0439c43"
          indexName="sysdig"
          placeholder="Search for Docs"
        />

        {/* Kapa AI button — full functionality preserved */}
        <a
          className="btn btn-success"
          id="kapaSearch"
          href="javascript:void(0);"
          type="button"
          style={{
            whiteSpace: "nowrap",
            display: "flex",
            alignItems: "center",
            gap: "5px",
            padding: "8px 16px",
            fontSize: "1rem",
          }}
        >
          <img
            className="nav-bar-ai-icon"
            src="/icons/icon-search.svg"
            alt=""
            style={{ width: "20px", height: "20px" }}
          />
          Ask AI →
        </a>
      </div>
    </section>
  );
};

export default DocHubHero;
